/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./transformersEdit.vue?vue&type=template&id=72019091&scoped=true"
import script from "./transformersEdit.vue?vue&type=script&lang=js"
export * from "./transformersEdit.vue?vue&type=script&lang=js"
import style0 from "./transformersEdit.vue?vue&type=style&index=0&id=72019091&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72019091",
  null
  
)

export default component.exports